module.exports = __webpack_public_path__ + "static/media/003.d415920f.jpg";